import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { UserRole } from 'src/app/models/users/user-role';
import { UserViewModel } from 'src/app/models/users/user-view.model';
export class UserDetailsComponent {
    constructor(route, router, userrService) {
        this.route = route;
        this.router = router;
        this.userrService = userrService;
        this.userRoles = [
            { value: UserRole.Admin, description: "Admin" },
            { value: UserRole.User, description: "User" },
            { value: UserRole.Documenter, description: "Documenter" }
        ];
    }
    ngOnInit() {
        this.route.data.subscribe(value => {
            this.user = value.user || UserViewModel.make(null);
        });
    }
    save() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            if (!this.user.firstName || !this.user.lastName || !this.user.username || (!this.user.id && !this.user.password))
                return;
            this.execute();
        });
    }
    execute() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            this.user.userRole = Number.parseInt(this.user.userRole.toString());
            if (!this.user.id)
                this.user.id = yield this.userrService.create(this.user);
            else
                yield this.userrService.update(this.user);
            this.router.navigate(['/admin/users']);
        });
    }
}
